import React ,{useState,useMemo}from 'react'
import SearchImg from '../../assets/icons/Search.png'
import {FormControl,InputLabel,OutlinedInput,InputAdornment} from '@mui/material'
import { debounce } from 'lodash'
const SearchTable=React.memo((props)=>{
    let height=props.height?props.height:40
    let width=props.width?props.width:200
    let borderRadius=props.borderRadius?props.borderRadius:10
    return (
        <FormControl variant="outlined">
            {/* <InputLabel htmlFor="input-with-icon-textfield">Search</InputLabel> */}
            <OutlinedInput
                size='small'
                {...props}
                style={{height:height,width:width,borderRadius:borderRadius}}
                // value={props.search}
                id="input-with-icon-textfield"
                name='password'
                onChange={(e)=>props.searchToggle(e.target.value)}
                // onKeyPress={e =>props.handleKeyPress(e)}
                required
                startAdornment={
                <InputAdornment position="start">
                    <img alt="search" src={SearchImg} style={{width:15}}/>
                </InputAdornment>
                }
                labelWidth={50}
            />
        </FormControl>
    )
})
export default SearchTable